<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>公司管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
            <el-col :span="8" >
                    <span>公司名称:</span>
                    <el-input placeholder="请输入公司名称" v-model="queryInfo.name" class="m-l-30 ell-input" ></el-input>
            </el-col>
               
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
            <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchCompany()">查询</el-button>
                <el-button type="primary" @click="showDialog()">添加</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="companyList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="公司名称" prop="name" width="250"></el-table-column>
            <el-table-column label="公司联系人" prop="contacts" width="250"></el-table-column>
            <el-table-column label="电话" prop="phone" width="250"></el-table-column>
            <el-table-column label="操作" prop="" width="150" >
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="删除" placement="top"   >  
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row.id)" ></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
         <!-- 添加用户 -->
        <el-dialog title="添加公司"  :visible.sync="addDialogVisible"  width=" 30%" @close="addDialogClose" class="dialog">
                
                <el-form ref="addCompanyFromRef" :model="addCompanyFrom"  :rules="addCompanyFromRules" >
                    <el-row>
                         <el-col >
                                <el-form-item label="公司名称:" label-width="100px" prop="name">
                                    <el-input v-model="addCompanyFrom.name"   placeholder="请输入公司名称"  style="width:80%" ></el-input>
                                </el-form-item>
                                <el-form-item label="联系人:" label-width="100px" prop="contacts">
                                    <el-input v-model="addCompanyFrom.contacts" placeholder="请输入联系人"  style="width:80%" ></el-input>
                                </el-form-item>
                                <el-form-item label="电话:" label-width="100px" prop="phone">
                                    <el-input v-model="addCompanyFrom.phone" placeholder="请输入手机号"     style="width:80%" ></el-input>
                                </el-form-item>
                          </el-col>
                    </el-row>
                </el-form>
                 <!-- 底部区 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addCompany()">确 定</el-button>
                </span>
        </el-dialog>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="queryInfo.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
    </el-card >
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'machine',
  data(){
        var checkZF=(rule,value,cb)=>{
            if(value.length>0){
                value=value.replace(/\s/g, "");
                if(value.length<6){
                    cb(new Error('请输入最少6个字符!'))
                }
            }
            var zF = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(!zF.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
        }
        var checkCompany=(rule,value,cb)=>{
            if(value.length>0){
                value=value.replace(/\s/g, "");
                if(value.length<2){
                    cb(new Error('请输入最少2个字符!'))
                }
            }
            var checkCy = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(!checkCy.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
        }
        var checkphone=(rule,value,cb)=>{
            //value=value.replace(/\s/g,"")
            const  regPhone= /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if(regPhone.test(value)){
                return cb();
            }
            cb(new Error('请输入合法的手机号!'))
        }
        return {
          queryInfo:{
              name:'',
              num:1
          },
          addCompanyFrom:{

          },
           //添加用户的校验规则
          addCompanyFromRules:{
            name: [{required: true, message: '请输入公司名称!',  trigger: 'blur' },{ min: 6,  max: 32,  message: '长度在 6 到 32 个字符!',   trigger: 'blur' },{ validator : checkZF , trigger: 'blur'}],
            phone:    [{required: true, message: '请输入手机号!',  trigger: 'blur' },{ min: 11, max: 11, message: '长度为11字符!',           trigger: 'blur'} ,{ validator : checkphone , trigger: 'blur'}],
            contacts: [{required: true, message: '请输入公司联系人!',  trigger: 'blur' },{ min: 2,  max: 12,  message: '长度在 2 到 12 个字符!',   trigger: 'blur' },{ validator : checkCompany , trigger: 'blur'}],
          },
          addDialogVisible:false,
          companyList:[],
          total:0,  
      }
  },
//生命周期函数
  created(){
    this.searchCompany();
  },
  methods:{
    //删除公司
    deleteById(val){

         this.$http.get('/user/deleteCompany',{params :{id:val}})
        .then(response => {
                if (response.data.code === 200) {
                   this.searchCompany();
                }else{
                     return this.$message.error(response.data.message);
                }
            }).catch(failResponse => {

        })
    },
    searchCompany(){
        var check = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
        if(check.test(this.queryInfo.name)||check.test(this.queryInfo.phone)){
            return this.$message.error("请输入非特殊字符!");
        }
         this.$http.get('/user/selectCompany',{params :{name:this.queryInfo.name ,pageNum:this.queryInfo.num}})
        .then(response => {
                if (response.data.code === 200) {
                    this.companyList=response.data.result.data;
                    this.total=response.data.result.total;
                }else{
                     return this.$message.error(response.data.message);
                }
            }).catch(failResponse => {

        })
    },
    clearParams(){
        this.queryInfo.name="";
        //this.searchCompany();
    },
    handleCurrentChange(num){
        this.queryInfo.num=num;
        this.searchCompany();
    },
    addDialogClose(){
          this.$refs.addCompanyFromRef.resetFields();
    },
    addCompany(){
        this.$refs.addCompanyFromRef.validate(  valid => {
            if(!valid){  return;}
                this.$http.post('/user/addCompany',JSON.stringify(this.addCompanyFrom)) .then(response => {
                if (response.data.code === 200) {
                     this.$message.success("新增成功!");
                     this.searchCompany();
                     this.addDialogVisible=false
                    return 

            }else{
                     return this.$message.error(response.data.message);
            }
            }).catch(failResponse => {

            })
        })
    },
    //打开添加公司弹框
    showDialog(){
        this.addDialogVisible=true;
    },
  }
       
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 10px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 
</style>


// WEBPACK FOOTER //
// src/components/user/Company.vue